import fiatCurrencies from '@exodus/fiat-currencies';
import type { Selector } from 'reselect';
import { createSelector } from 'reselect';

import type { Assets } from '@/types/index.js';
import selectors from '../../selectors.js';
import type { FiatBalances, FiatCurrencies } from '../types.js';

const optimisticTotalEnabledBalanceSelector = createSelector(
  selectors.enabledAssets.data as Selector<unknown, Assets>,
  selectors.fiatBalances.byAssetInActiveAccount as Selector<
    unknown,
    FiatBalances
  >,
  selectors.locale.currency as Selector<unknown, string>,
  (enabledAssets, activeWalletAccountBalances = {}, currency) => {
    const fiatCurrency = (fiatCurrencies as FiatCurrencies)[currency];
    const enabledAssetNames = Object.keys(enabledAssets);

    return enabledAssetNames.reduce((totalBalance, assetName) => {
      const assetBalance =
        activeWalletAccountBalances[assetName] || fiatCurrency.ZERO;

      return totalBalance.add(assetBalance);
    }, fiatCurrency.ZERO);
  },
);

export default optimisticTotalEnabledBalanceSelector;
